<template>
 
   <v-layout align-start>
    <v-flex>
        <v-toolbar text color="white">
            <v-toolbar-title>Perspectivas</v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                <v-spacer></v-spacer>

                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark class="mb-3" v-on="on">Nueva Perspectiva</v-btn>
                    </template>

                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-row>
<!--                                       <v-col cols="12" sm="4" md="4">
                                            <v-text-field v-model="codigo_perspectiva" label="Codigo Perspectiva"></v-text-field>
                                        </v-col>
-->                                         
                                            <v-col cols="12" sm="6" md="12">
                                            <v-text-field v-model="nombre_perspectiva" label="Nombre Perspectiva"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="descripcion_perspectiva" label="Descripcion Perspectiva"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-flex xs12 sm12 md12 v-show="valida">
                                        <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">
                                        </div>
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click.native="close">Cancelar</v-btn>
                            <v-btn color="red darken-1" text @click.native="guardar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>cd
                </v-dialog>
 
                 <v-dialog v-model="adModal" max-width="290">
                    <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">¿Activar Item? </v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Item? </v-card-title>
                    <v-card-text>
                        Estas a punto del
                        <span v-if="adAccion==1">Activar </span>
                        <span v-if="adAccion==2">Desactivar </span>
                        el item {{ adIdPerspectiva}}    
                    </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text="text" @click="activarDesactivarCerrar">
                                    Cancelar
                                </v-btn>
                                <v-btn v-if="adAccion==1" color="orange darken-4" text="text" @click="activar">
                                    Activar
                                </v-btn>
                                <v-btn v-if="adAccion==2" color="orange darken-4" text="text" @click="desactivar">
                                    Desactivar
                                </v-btn>
                            </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>

   <v-data-table
        :headers="headers"
        :items="perspectivas"
        :search="search"
        class="elevation-1"
    >     
                <template v-slot:item.action="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                    >
                        mdi-grease-pencil
                    </v-icon>
                    <template v-if="item.estado_perspectiva">
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(2,item)"
                        >
                            mdi-block-helper
                        </v-icon>
                    </template>
                    <template v-else>
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(1,item)"
                        >
                            mdi-check-all
                        </v-icon>
                    </template>
                </template>

                <template slot="items" slot-scope="props">
                    <td>{{ props.item.codigo_perspectiva }}</td>
                    <td>{{ props.item.nombre_perspectiva }}</td>
                    <td>{{ props.item.descripcion_perspectiva }}</td>
                    <td>
                        <div v-if="props.item.estado_perspectiva">
                            <span class="blue--text">Activo</span>
                        </div>
                        <div v-else>
                            <span class="red--text">Inactivo</span>
                        </div>
                    </td>
                </template>

                <template slot="no-data">
                <v-btn color="primary" @click="listar">Resetear</v-btn>
                </template>
    </v-data-table>

        </v-flex>
    </v-layout>

</template>

<script>
import axios from 'axios'

export default {
    data(){
        return{
                perspectivas:[],                
                dialog: false,
                headers: [
                    { text: 'Opciones', value: 'action', sortable: false},
                    { text: 'Cod. Perspectiva', value: 'codigo_perspectiva' },
                    { text: 'Perspectiva', value: 'nombre_perspectiva' , sortable: false},                    
                    { text: 'Descripción', value: 'descripcion_perspectiva' , sortable: false},
                    { text: 'Estado', value: 'estado_perspectiva' , sortable: false}
                ],
                search: '',
                editedIndex: -1,
                codigo_perspectiva:'',
                nombre_perspectiva:'',
                descripcion_perspectiva: '',
                estado_perspectiva:'',               
                valida: 0,
                validaMensaje:[],
                adModal: 0,
                adAccion: 0,
                adIdPerspectiva:'',
                adNombre:''
        }
    },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Nueva Perspectiva' : 'Actualizar Perspectiva'
            }
        },


    watch: {
        dialog (val) {
        val || this.close()
        },
    },

    created () {
        this.listar();
        this.select();
    },
    methods:
    {
		listar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};            
			axios.get('api/Perspectivas/Listar',configuracion).then(function(response){
				//console.log(response);
				me.perspectivas=response.data;
			}).catch(function(error){
				console.log(error);   
			});
		},

    editItem (item) {
 			this.adIdPerspectiva=item.id_perspectiva;
            this.nombre_perspectiva= item.nombre_perspectiva;
			this.descripcion_perspectiva=item.descripcion_perspectiva;
			this.estado_perspectiva=item.estado_perspectiva;
            this.editedIndex=1;            
			this.dialog = true
		},

		close () {
            this.dialog = false;
            this.limpiar();
		},

		limpiar(){
            this.codigo_perspectiva= "";
            this.nombre_perspectiva= "";
			this.descripcion_perspectiva= "";
			this.editedIndex=-1;
		},


		guardar () {
            
			if(this.validar()){
				return;
			}
			if (this.editedIndex > -1) {
				// codigo para guardar
				let me=this;
				axios.put('api/Perspectivas/Actualizar',{
                    'id_perspectiva':me.adIdPerspectiva,
//					'codigo_perspectiva': me.codigo_perspectiva,
					'nombre_perspectiva': me.nombre_perspectiva,
					'descripcion_perspectiva':me.descripcion_perspectiva
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
				});

			} else {
		   //     this.desserts.push(this.editedItem)
				let me=this;
				axios.post('api/Perspectivas/Crear',{
					'codigo_perspectiva': me.codigo_perspectiva,
					'nombre_perspectiva': me.nombre_perspectiva,
					'descripcion_perspectiva':me.descripcion_perspectiva
				}).then(function(response){
					me.close(); 
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
                });
                
			}
        },

		validar(){
			this.valida=0;
			this.validaMensaje=[];
            if(!this.nombre_perspectiva){
				this.validaMensaje.push("Digite un nombre_perspectiva");
            }            
			if(this.nombre_perspectiva < 3 || this.nombre_perspectiva > 100){
				this.validaMensaje.push("El Nombre indicador debe tener mas de 3 caracteres y menos de 100 caracteres.");
            }
		    if(this.validaMensaje.length){
				this.valida=1;
			}
		    return this.valida;
        },

        activarDesactivarMostrar(accion,item){
        this.adModal=1;
        this.adIdPerspectiva =item.id_perspectiva;
        if (accion==1){
            this.adAccion=1;
        }
        else if (accion==2){
        this.adAccion=2;
        }
        else{
        this.adModal=0;
        }
        },
        activarDesactivarCerrar(){
        this.adModal=0;
        },
        activar(){
            let me=this;
            axios.put('api/Perspectivas/Activar/'+this.adIdPerspectiva,{}).then(function(response){
            me.adModal=0;
            me.adAccion=0;
            me.adNombre="";
            me.adIdPerspectiva="";
            me.listar();                       
            }).catch(function(error){
                console.log(error);
            });
        },
        desactivar(){
            let me=this;
            axios.put('api/Perspectivas/Desactivar/'+this.adIdPerspectiva,{}).then(function(response){
                me.adModal=0;
                me.adAccion=0;
                me.adIdPerspectiva="";
                me.adNombre="";
                me.listar();                       
            }).catch(function(error){
            console.log(error);
        });
            }
        }        
    }
</script>